import { createStore, useStore } from "./store";

export interface UsageState {
  tokensToday: number;
  tokensPerDay: number;
}

export const usageStore = createStore<UsageState>({ tokensToday: 0, tokensPerDay: 0 });
export const useUsage = () => useStore(usageStore);

/** Fired when the proxy says the session is gone (expired, revoked, disabled). */
export const sessionEvents = new EventTarget();

/** fetch wrapper for proxy calls: picks up live usage headers and session loss. */
export const trackingFetch: typeof fetch = async (input, init) => {
  const res = await fetch(input, init);
  const today = res.headers.get("X-Demo-Tokens-Today");
  const limit = res.headers.get("X-Demo-Tokens-Limit");
  if (today !== null) usageStore.set({ tokensToday: Number(today), tokensPerDay: Number(limit ?? usageStore.get().tokensPerDay) });
  if (res.status === 401 || (res.status === 403 && res.headers.get("content-type")?.includes("json"))) {
    const body = await res.clone().json().catch(() => ({}));
    if (res.status === 401 || String(body.code ?? "").startsWith("account_")) {
      sessionEvents.dispatchEvent(new CustomEvent("lost", { detail: body.error }));
    }
  }
  return res;
};
